import React, { useEffect, useState } from 'react';
import StrategyForm from './Components/StrategyForm';
import { AuthenticateApi } from './api';
import { FlatList, Image } from 'react-native';
import LoginForm from './Components/LoginForm';
import { Text, View, Button } from '../Components/Themed';
import type { AuthStrategyIdentifierProps, AuthStrategyProps, AuthenticatedProps } from './api/types';
import { APIOverrides } from '../ApiOverrides';
import type { CompanyProps, FocusPositionProps } from '../types';
import { useColors } from '../constants/useColors';


type AuthenticateWizardProps = {
    auth_strategy_id:string,
    maxWidth?:number,
    company_id?:string,
    default_view?:'login'|'register'
    show_referral?:boolean,
    source:string,
    onFocusPosition?:(data:FocusPositionProps) => void,
    theme?:'full'|'mini'
    opt_in_url?:string,
    referral_code?:string,
    visible?:boolean,
    onAuthenticated: (auth_response:AuthenticatedProps) => void,
    onTryAuthenticate?: (attribute:string, result:'success'|'fail') => void
    onClose: () => void
}

const auth_sections = ['header','strategy','login','actions']
const Authenticator = ({ show_referral, auth_strategy_id, onFocusPosition, default_view, company_id, source, referral_code, maxWidth, opt_in_url, onTryAuthenticate, onAuthenticated, onClose }:AuthenticateWizardProps) => {
    const C = useColors();
    const [ company, setCompany ] = useState<CompanyProps>();
    const [ distinct_id, setDistinctID ] = useState<string>();
    const [ active_view, setActiveView ] = useState(default_view ?? 'register')
    const [ strategy, setStrategy ] = useState<{
        loading:boolean,
        auth_strategy?:AuthStrategyProps,
        auth_strategy_identifiers:AuthStrategyIdentifierProps[]
    }>({
        loading: false,
        auth_strategy:undefined,
        auth_strategy_identifiers:[]
    });

    console.log('hey')
    useEffect(() => {
        getWidgetData();
    },[auth_strategy_id])

    useEffect(() => {
        if(!company_id){ return }
        getCompanyFromServer(company_id);
    },[company_id])

    useEffect(() => {
        if(!default_view){ return }
        setActiveView(default_view)
    },[default_view])

    const getCompanyFromServer = async(company_id:string) => {
        const company_resp = await AuthenticateApi.getCompanyById(company_id)
        setCompany(company_resp.company)
    }

    const getWidgetData = async() => {
        AuthenticateApi.setEnvironment();
        const distinct_id = await APIOverrides.getDistinctID()
        setDistinctID(distinct_id)

        const { auth_strategy, auth_strategy_identifiers } = await AuthenticateApi.getAuthStrategyById(auth_strategy_id);        
        setStrategy({
            ...strategy,
            auth_strategy,
            auth_strategy_identifiers,
            loading:false
        })
    }

    const handleAuthenticated = async(auth_response:AuthenticatedProps) => {
        return onAuthenticated(auth_response)
    }

    const renderSections = (data: { item:string, index:number }) => {
        switch(data.item){
            case 'header':
                if(!company){ return <></> }
                return (
                    <View type='header' style={{ padding:20, flexDirection:'row', alignItems:'center', borderTopRightRadius:8, borderTopLeftRadius:8, borderBottomWidth:1, borderColor:C.borders.light }}>
                        <View transparent style={{ flex:1, marginRight:10 }}>
                            <Text size={28} theme='h1' color={C.text.h1}>{active_view == 'login' ? 'Log In!': 'Welcome!'}</Text>
                            <Text theme='h2'>{active_view == 'login' ? 'Continue to login with':'Complete the form below to participate with'} {company?.company_name ?? 'Bettoredge'}</Text>
                        </View>
                        <View float style={{ borderRadius:100, padding:10, backgroundColor:C.text.white }}>
                            <Image
                                source={{ uri: company?.company_image?.url }}
                                style={{ width: 50, height: 50, borderRadius:8 }}
                                resizeMode='cover'
                            />
                        </View>   
                    </View>
                )
            case 'strategy':
                console.log('RENDERING STRAGETEG')
                return (
                    <StrategyForm
                        visible={active_view == 'register' ? true : false}
                        maxWidth={maxWidth}
                        company={company}
                        strategy={strategy}
                        onFocusPosition={onFocusPosition}
                        onLogin={() => setActiveView('login')}
                        auth_strategy_id={auth_strategy_id}
                        company_id={company_id}
                        show_referral={show_referral}
                        distinct_id={distinct_id ?? ''}
                        source={source}
                        referral_code={referral_code ?? 'tipoff'}
                        opt_in_url={opt_in_url}
                        onAuthenticated={handleAuthenticated}
                    />
                )
            case 'login':
                return (
                    <LoginForm
                        maxWidth={maxWidth}
                        visible={ active_view == 'login' ? true : false }
                        onAuthenticated={handleAuthenticated}
                        onFocusPosition={onFocusPosition}
                        onTryAuthenticate={(attribute, result) => onTryAuthenticate ? onTryAuthenticate(attribute, result) : console.log()}
                        onRegister={() => setActiveView('register')}
                    />
                )
            default: return <></>
        }
    }

    return (
        <View transparent>
            <View transparent>
                <FlatList
                    key='auth_section_list'
                    keyExtractor={(item) => item}
                    data={auth_sections}
                    renderItem={renderSections}
                />
            </View>
            <View type='footer' style={{ padding:10, flexDirection:'row', alignItems:'center', borderBottomRightRadius:8, borderBottomLeftRadius:8 }}>
                <Button
                    title='CLOSE'
                    title_color={C.text.error}
                    style={{ flex:1 }}
                    type='close'
                    onPress={() => onClose()}
                />
            </View>
        </View>
    )
}

export default Authenticator
